import { default as adspertInfo } from '../../../../adspt.config.json';

export const environment = {
  production: true,
  connectApp: {
    errCodes: {
      INTERNAL_GENERIC: 'INTERNAL-GENERIC',
      OAUTH_REJECTED: 'OAUTH-REJECTED',
      NO_ACCOUNTS: 'NO-ACCOUNTS',
      ACCOUNT_EXISTS: 'ACCOUNT-EXISTS',
      INSUFFICIENT_PERMISSIONS: 'INSUFFICIENT-PERMISSIONS',
      OAUTH_MS_WORK_ACCOUNT: 'OAUTH-MS-WORK-ACCOUNT',
    },
    status: {
      CREATE_USER: 'CREATE_USER', // this status doesnt exist in the backend, only for FE use
      ERROR: 'ERROR', // this status doesnt exist in the backend, only for FE use
      NONE: 'NONE',
      OAUTH_CONSENT: 'OAUTH-CONSENT',
      TERMS_CONSENT: 'TERMS-CONSENT',
      ACCOUNT_LIST_RETRIEVAL: 'ACCOUNT-LIST-RETRIEVAL',
      ACCOUNT_SELECTION: 'ACCOUNT-SELECTION',
      ACCOUNT_SYNC: 'ACCOUNT-SYNC',
      CUSTOMER_SETUP: 'CUSTOMER-SETUP',
    },
    accounts: {
      GOOGLE: 'Google Ads',
      AMAZON: 'Amazon Ads',
      MICROSOFT: 'Microsoft Advertising',
      EBAY: 'eBay',
      WALMART: 'Walmart Connect',
    },
  },
  app: {
    name: 'Adspert',
    stages: adspertInfo.apollo.stageConfigurations,
    version: adspertInfo.apollo.version,
    stripeLibUrl: 'https://js.stripe.com/v3/',
    countryFlagUrl: 'https://d2m8tbbygx8orx.cloudfront.net/shared/2020-12-07-A/country-flags/',
    cdnURL: adspertInfo.apollo.cdnPath + adspertInfo.apollo.version + '/',
    translationsUrl: adspertInfo.apollo.cdnPath + adspertInfo.apollo.version + '/assets/i18n/',
    explorerAppUrl: 'https://dashboard-beta.adspert.net/explorer/',
    resources: {
      dashboard: 'v3/',
    },
    sentry: {
      key: 'https://05b65fbef09b715e6ea8cecb19bf8299@o4507922024038400.ingest.de.sentry.io/4507932598468688',
    },
    googleAnalytics: {
      url: 'https://www.google-analytics.com/analytics.js',
      active: true,
      uaId: 'UA-137600721-2',
      logging: {
        debug: false,
        exceptions: true,
      },
    },
    platforms: {
      GOOGLE: {
        active: true,
        isPlatform: true,
        name: 'GOOGLE',
        logo: 'https://d2m8tbbygx8orx.cloudfront.net/adspert/platform-logos/google.svg',
      },
      AMAZON: {
        active: true,
        isPlatform: true,
        name: 'AMAZON',
        logo: 'https://d2m8tbbygx8orx.cloudfront.net/adspert/platform-logos/amazon.svg',
        logo_invert: 'assets/amazon-sp-invert.svg',
      },
      MICROSOFT: {
        active: true,
        isPlatform: true,
        name: 'MICROSOFT',
        logo: 'https://d2m8tbbygx8orx.cloudfront.net/adspert/platform-logos/microsoft.svg',
      },
      EBAY: {
        active: true,
        isPlatform: true,
        name: 'EBAY',
        logo: 'https://d2m8tbbygx8orx.cloudfront.net/adspert/platform-logos/ebay-padding.png',
      },
      WALMART: {
        active: true,
        isPlatform: true,
        name: 'WALMART',
        logo: 'https://d2m8tbbygx8orx.cloudfront.net/adspert/platform-logos/walmart_beta.png',
      },
    },
  },
};
